import { Card, CardHeader } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Card)`
  gap: 0 !important;
  width: 100%;
`;

export const Header = styled(CardHeader)``;
